import PropTypes from 'prop-types';

const patientLabelPropType = PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
});

export default patientLabelPropType;
